module.exports = __webpack_public_path__ + "img/menu_button_playnow_normal_cn@2x.7e41f277.png";